import { useRef, useMemo, forwardRef, Ref, useImperativeHandle } from 'react';

import { useNotificationSound } from 'hooks/useNotificationSound';

import sound1 from './sound1.mp3';
import sound2 from './sound2.mp3';
import sound3 from './sound3.mp3';
import sound4 from './sound4.mp3';
import sound5 from './sound5.mp3';
import sound6 from './sound6.mp3';
import sound7 from './sound7.mp3';
import sound8 from './sound8.mp3';
import sound9 from './sound9.mp3';
import sound10 from './sound10.mp3';

const SoundMapper = {
  sound1,
  sound2,
  sound3,
  sound4,
  sound5,
  sound6,
  sound7,
  sound8,
  sound9,
  sound10,
};

interface SoundProps {}

export interface SoundRef {
  play: () => void;
}

export const Sound = forwardRef((props: SoundProps, ref: Ref<SoundRef>) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const notificationSound = useNotificationSound();

  const source = useMemo(() => {
    return SoundMapper[notificationSound] || sound1;
  }, [notificationSound]);

  useImperativeHandle(
    ref,
    () => ({
      play: () => {
        audioRef?.current?.play();
      },
    }),
    [],
  );

  return (
    <audio key={source} ref={audioRef}>
      <source src={source} type="audio/mp3" />
      <track kind="captions" />
    </audio>
  );
});
